module.exports = __webpack_public_path__ + "static/media/review_cf.5d3b8f78.png";